import { FinancialAccountSubtype } from '../../../__generated__/globalTypes';

export interface IPreselectableAccount {
  id: string;
  subtype: FinancialAccountSubtype;
}

/**
 * Which account the picker opens on.
 *
 * The spec asks for the household's *primary* checking — the one with the
 * highest transaction count, or the direct-deposit destination. Neither signal
 * reaches the client: `FinancialAccount` exposes no transaction count, no
 * direct-deposit flag, and no primary marker. So this picks the first checking
 * account and falls back to the first eligible one, which is the closest
 * honest approximation.
 *
 * Getting this wrong costs a tap, never a wrong debit — the authorization
 * screen restates the account, and nothing is charged without it.
 */
export function preselectAccountId(accounts: readonly IPreselectableAccount[]): string | null {
  const checking = accounts.find((account) => account.subtype === FinancialAccountSubtype.Checking);
  return checking?.id ?? accounts[0]?.id ?? null;
}
